'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy(slug, title, summary, category, icon, readTime, challenge, solution, results, quote, sections) {
  this.dK = null;
  this.dL = null;
  this.fz = null;
  this.gk = null;
  this.gl = null;
  this.i0 = null;
  this.hZ = null;
  this.i3 = null;
  this.i1 = null;
  this.fy = null;
  this.i2 = null;
  this.dK = slug;
  this.dL = title;
  this.fz = summary;
  this.gk = category;
  this.gl = icon;
  this.i0 = readTime;
  this.hZ = challenge;
  this.i3 = solution;
  this.i1 = results;
  this.fy = quote;
  this.i2 = sections;
}
export { $c_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy as $c_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy };
$p = $c_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy() {
}
export { $h_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy as $h_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy };
$h_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-1771096329), true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy)) {
    if ((((((((this.dK === x$0.dK) && (this.dL === x$0.dL)) && (this.fz === x$0.fz)) && (this.gk === x$0.gk)) && (this.gl === x$0.gl)) && (this.i0 === x$0.i0)) && (this.hZ === x$0.hZ))) {
      var x = this.i3;
      var x$2 = x$0.i3;
      var $x_3 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.i1;
      var x$4 = x$0.i1;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.fy;
      var x$6 = x$0.fy;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.i2;
      var x$8 = x$0.i2;
      return ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 11;
});
$p.I = (function() {
  return "CaseStudy";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.dK;
      break;
    }
    case 1: {
      return this.dL;
      break;
    }
    case 2: {
      return this.fz;
      break;
    }
    case 3: {
      return this.gk;
      break;
    }
    case 4: {
      return this.gl;
      break;
    }
    case 5: {
      return this.i0;
      break;
    }
    case 6: {
      return this.hZ;
      break;
    }
    case 7: {
      return this.i3;
      break;
    }
    case 8: {
      return this.i1;
      break;
    }
    case 9: {
      return this.fy;
      break;
    }
    case 10: {
      return this.i2;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.br)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy as $isArrayOf_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy };
var $d_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy, "io.intela.sites.digitalinternship.data.CaseStudies$CaseStudy", ({
  br: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy as $d_Lio_intela_sites_digitalinternship_data_CaseStudies$CaseStudy };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Case-Studies$-Case-Study.js.map
